export default "__VITE_ASSET__ytkHz1IW__"